export default "<splash-screen *ngIf=\"loader\"></splash-screen> <router-outlet></router-outlet>\n";